import * as PodcastConstants from './constants';

export function setActiveBackstageProgramId({ programId }) {
  return {
    type: PodcastConstants.ActionTypes.SET_ACTIVE_BACKSTAGE_PROGRAM_ID,
    data: {
      programId,
    },
  };
}

export function requestGetDetails({ pandoraId, sortingOrder }) {
  return {
    type: PodcastConstants.ActionTypes.REQUEST_PODCAST_GET_DETAILS,
    data: {
      pandoraId,
      sortingOrder,
    },
  };
}

export function requestAllThumbedEpisodes({ pandoraId, isPositive }) {
  return {
    type: PodcastConstants.ActionTypes.REQUEST_ALL_THUMBED_EPISODES,
    data: {
      pandoraId,
      isPositive,
    },
  };
}

export function requestAllEpisodesByProgram({ pandoraId, sortingOrder }) {
  return {
    type: PodcastConstants.ActionTypes.REQUEST_ALL_EPISODES_BY_PROGRAM,
    data: {
      pandoraId,
      sortingOrder,
    },
  };
}

export function addEpisodeToThumbsList(episodeId) {
  return {
    type: PodcastConstants.ActionTypes.ADD_EPISODE_TO_THUMBS_LIST,
    data: {
      episodeId,
    },
  };
}

export function removeEpisodeFromThumbsList(episodeId) {
  return {
    type: PodcastConstants.ActionTypes.REMOVE_EPISODE_FROM_THUMBS_LIST,
    data: {
      episodeId,
    },
  };
}

export function updatePodcastEpisodeProgress({ pandoraId, elapsedTime, isFinished }) {
  return {
    type: PodcastConstants.ActionTypes.UPDATE_PODCAST_EPISODE_PROGRESS,
    data: {
      pandoraId,
      elapsedTime,
      isFinished,
    },
  };
}

export function removeEpisodesFeedback({ episodeIds, pandoraId }) {
  return {
    type: PodcastConstants.ActionTypes.AESOP_REMOVE_EPISODES_FEEDBACK,
    data: {
      episodeIds,
      pandoraId,
    },
  };
}
